<template>
    <div class="in-app-modal">
        <InAppPreviewLayout>
            <template v-slot:vertical>
                <div class="in-app-modal-vertical">
                    <div
                        class="in-app-modal-vertical-body"
                        :style="{
                            display:
                                template.InAppProps.Image.URL &&
                                template.InAppProps.Image.URL.length
                                    ? 'grid'
                                    : 'block',
                        }"
                    >
                        <img
                            src="@/assets/images/inApp/modal/close.svg"
                            alt=""
                            class="in-app-modal-vertical-body__close"
                        />

                        <span
                            :style="{
                                fontSize:
                                    +template.InAppProps.Styling.Title
                                        .FontSize *
                                        textSmallingCoef +
                                    'px',
                                color: template.InAppProps.Styling.Title.Color,
                                height:
                                    +template.InAppProps.Styling.Title
                                        .FontSize *
                                        textSmallingCoef +
                                    'px',
                                lineHeight:
                                    +template.InAppProps.Styling.Title
                                        .FontSize *
                                        textSmallingCoef +
                                    'px',
                            }"
                            class="in-app-modal-vertical-body__title"
                            >{{ template.Title || template.Subject }}</span
                        >

                        <img
                            v-if="
                                template.InAppProps.Image.URL &&
                                template.InAppProps.Image.URL.length
                            "
                            class="in-app-modal-vertical-body__image"
                            :src="template.InAppProps.Image.URL"
                            alt=""
                        />

                        <span
                            :style="{
                                fontSize:
                                    +template.InAppProps.Styling.Desc.FontSize *
                                        textSmallingCoef +
                                    'px',
                                color: template.InAppProps.Styling.Desc.Color,
                                height:
                                    (+template.InAppProps.Styling.Desc
                                        .FontSize +
                                        1) *
                                        textSmallingCoef *
                                        3 +
                                    'px',
                                lineHeight:
                                    +(
                                        template.InAppProps.Styling.Desc
                                            .FontSize + 1
                                    ) *
                                        textSmallingCoef +
                                    'px',
                            }"
                            class="in-app-modal-vertical-body__text"
                            >{{ template.Template }}</span
                        >

                        <div
                            class="in-app-modal-vertical-body__button-wrapper"
                        ></div>

                        <span
                            v-if="template.InAppProps.PrimaryButton.Title"
                            @click="
                                onOpenUrl(
                                    template.InAppProps.PrimaryButton.ActionURL
                                )
                            "
                            class="in-app-modal-vertical-body__button"
                            :style="{
                                color:
                                    template.InAppProps.Styling
                                        .PrimaryButtonColor,
                                backgroundColor:
                                    template.InAppProps.PrimaryButton
                                        .BackgroundColor,
                            }"
                            >{{ template.InAppProps.PrimaryButton.Title }}</span
                        >
                    </div>
                </div>
            </template>
            <template v-slot:horizontal>
                <div class="in-app-modal-horizontal">
                    <img
                        src="@/assets/images/inApp/modal/close.svg"
                        alt=""
                        class="in-app-modal-horizontal__close"
                    />

                    <div
                        class="in-app-modal-horizontal-body"
                        :style="{
                            display:
                                template.InAppProps.Image.URL &&
                                template.InAppProps.Image.URL.length
                                    ? 'grid'
                                    : 'block',
                        }"
                    >
                        <div
                            class="in-app-modal-horizontal-body__image"
                            :style="{
                                backgroundImage: `url(${template.InAppProps.Image.URL})`,
                            }"
                            v-show="
                                template.InAppProps.Image.URL &&
                                template.InAppProps.Image.URL.length
                            "
                        ></div>

                        <div
                            class="in-app-modal-horizontal-body__right"
                            :style="{
                                textAlign:
                                    template.InAppProps.Image.URL &&
                                    template.InAppProps.Image.URL.length
                                        ? 'left'
                                        : 'center !important',
                            }"
                        >
                            <span
                                class="in-app-modal-horizontal-body__title"
                                :style="{
                                    fontSize:
                                        +template.InAppProps.Styling.Title
                                            .FontSize *
                                            textSmallingCoef +
                                        'px',
                                    color:
                                        template.InAppProps.Styling.Title.Color,
                                    height:
                                        +template.InAppProps.Styling.Title
                                            .FontSize *
                                            textSmallingCoef +
                                        'px',
                                    lineHeight:
                                        +template.InAppProps.Styling.Title
                                            .FontSize *
                                            textSmallingCoef +
                                        'px',
                                }"
                                >{{ template.Title || template.Subject }}</span
                            >

                            <span
                                :style="{
                                    fontSize:
                                        +template.InAppProps.Styling.Desc
                                            .FontSize *
                                            textSmallingCoef +
                                        'px',
                                    color:
                                        template.InAppProps.Styling.Desc.Color,
                                    height:
                                        (+template.InAppProps.Styling.Desc
                                            .FontSize +
                                            2) *
                                            textSmallingCoef *
                                            3 +
                                        'px',
                                    lineHeight:
                                        +(
                                            template.InAppProps.Styling.Desc
                                                .FontSize + 2
                                        ) *
                                            textSmallingCoef +
                                        'px',
                                }"
                                class="in-app-modal-horizontal-body__text"
                                >{{ template.Template }}</span
                            >

                            <div
                                class="in-app-modal-horizontal-body__button-wrapper"
                                :style="{
                                    width:
                                        template.InAppProps.Image.URL &&
                                        template.InAppProps.Image.URL.length
                                            ? '0'
                                            : null,
                                }"
                            >
                                <span
                                    v-if="
                                        template.InAppProps.PrimaryButton.Title
                                    "
                                    @click="
                                        onOpenUrl(
                                            template.InAppProps.PrimaryButton
                                                .ActionURL
                                        )
                                    "
                                    class="in-app-modal-horizontal-body__button"
                                    :style="{
                                        color:
                                            template.InAppProps.Styling
                                                .PrimaryButtonColor,
                                        backgroundColor:
                                            template.InAppProps.PrimaryButton
                                                .BackgroundColor,
                                        margin:
                                            template.InAppProps.Image.URL &&
                                            template.InAppProps.Image.URL.length
                                                ? '0 auto'
                                                : '0',
                                    }"
                                    >{{
                                        template.InAppProps.PrimaryButton.Title
                                    }}</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </InAppPreviewLayout>
    </div>
</template>

<script>
import InAppPreviewLayout from "../InAppPreviewLayout.vue";
export default {
    name: "in-app-modal",
    props: {
        template: {
            type: Object,
            default: null,
        },
    },
    data: () => ({
        textSmallingCoef: 0.7,
    }),
    components: {
        InAppPreviewLayout,
    },
    methods: {
        onOpenUrl(url) {
            window.open(url, "_blank");
        },
    },
};
</script>

<style lang="scss">
.in-app-modal {
    &-vertical {
        background: #ffffff;
        border-radius: 10px;
        height: 47%;
        width: 75%;
        margin: 0 auto;
        position: relative;
        bottom: -22%;

        &-body {
            height: 100%;
            grid-template-columns: 1fr;
            height: 100%;
            padding: 0 8px 8px 8px;

            &__close {
                display: block;
                margin: 0 0 0 auto;
                position: relative;
                top: -4px;
                left: auto;
                right: -12px;
                margin-bottom: -5px;
            }

            &__title {
                text-align: center;
                font-weight: bold;
                display: block;
                margin: 0 auto;
                text-overflow: ellipsis;
                margin-bottom: 5px;
                overflow: hidden;
            }

            &__image {
                display: block;
                overflow: hidden;
                margin: 0 auto 5px auto;
                max-width: 80%;
                max-height: 100%;
            }

            &__text {
                text-align: center;
                font-size: 8px;
                display: block;
                margin: 4px auto 0 auto;
                overflow: hidden;
                text-overflow: ellipsis;
                align-self: stretch;
                margin-bottom: 5px;
            }

            &__button-wrapper {
                grid-template-columns: 1fr;
                align-self: flex-end;
                justify-items: center;
            }

            &__button {
                display: block;
                line-height: 1;
                padding: 4px 10px;
                font-size: 6px;
                text-align: center;
                cursor: pointer;
                overflow: hidden;
                max-width: 50%;
                text-overflow: ellipsis;
                align-self: flex-end;
                box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.15);
                border-radius: 3px;
                margin: 0 auto;
            }
        }
    }

    $inAppModalHeight: 95px;
    $inAppModalWidth: 200px;
    $inAppModalPadding: 8px;
    $inAppModalInnerHeight: $inAppModalHeight - 2 * $inAppModalPadding;
    $inAppModalInnerWidth: $inAppModalWidth - 2 * $inAppModalPadding;

    &-horizontal {
        background: #ffffff;
        border-radius: 10px;
        height: $inAppModalHeight;
        width: $inAppModalWidth;
        margin: 0 auto;
        position: relative;
        bottom: -22.5%;

        &__close {
            display: block;
            margin: 0 0 0 auto;
            position: relative;
            top: -4px;
            left: auto;
            right: -4px;
            margin-bottom: -14px;
        }

        &-body {
            height: 100%;
            display: grid;
            grid-gap: 14px;
            grid-template-columns: $inAppModalInnerHeight 1fr;
            padding: $inAppModalPadding;
            align-items: center;
            text-align: center;

            &__image {
                display: block;
                line-height: 1;
                overflow: hidden;
                background-position: center;
                background-size: cover;
                height: 79px;
                width: 79px;
            }

            &__right {
                display: block;
                height: 100%;
                text-align: left;
            }

            &__title {
                overflow: hidden;
                font-weight: bold;
                display: block;
                margin: 0 auto;
                text-overflow: ellipsis;
                margin-bottom: 5px;
            }

            &__text {
                font-size: 8px;
                display: block;
                margin: 4px auto 0 auto;
                overflow: hidden;
                text-overflow: ellipsis;
                align-self: stretch;
                margin-bottom: 5px;
            }

            &__button-wrapper {
                grid-template-columns: 1fr;
                align-self: flex-end;
                position: absolute;
                bottom: 8px;
                width: $inAppModalInnerWidth;
            }

            &__button {
                display: inline-block;
                line-height: 1;
                padding: 4px 10px;
                font-size: 6px;
                text-align: center;
                cursor: pointer;
                overflow: hidden;
                margin: 0 auto;

                text-overflow: ellipsis;
                align-self: flex-end;
                box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.15);
                border-radius: 3px;
                margin: 0 auto;
            }
        }
    }
}
</style>
